import { memo } from 'react';
import Button from '@mui/material/Button';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import BootstrapTooltip from 'views/Components/Shared/Components/BootstrapTooltip';

const InfoTooltip = memo(({ title }) => {
	return (
		<BootstrapTooltip title={title} placement="top">
			<Button
				sx={{
					minWidth: 'fit-content',
					padding: '0',
					paddingBottom: '2px',
				}}
			>
				<InfoOutlinedIcon
					sx={{
						color: '#00000061',
						height: '15px',
						width: '15px',
					}}
				/>
			</Button>
		</BootstrapTooltip>
	);
});

export default InfoTooltip;
